import { createBrowserHistory } from 'history';
import { createStore, applyMiddleware, compose } from 'redux';
// import { routerMiddleware } from 'connected-react-router';
import reduxThunk from 'redux-thunk';
import { createReduxHistoryContext } from 'redux-first-history';
//
import rootReducer from './rootReducer';

const windowDefined =
  typeof window !== 'undefined' &&
  typeof window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ === 'function';

// Create a history of your choosing (we're using a browser history in this case)
const { createReduxHistory, routerMiddleware, routerReducer } = createReduxHistoryContext({
  history: createBrowserHistory(),
});
// export const history = windowDefined ? createBrowserHistory() : createMemoryHistory();
// Build the middleware for intercepting and dispatching navigation actions

// add support for Redux dev tools
const composeEnhancers =
  windowDefined && process.env.NODE_ENV !== 'production'
    ? window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__({ trace: true, traceLimit: 25 }) || compose
    : compose;

function configureStore(init = {}) {
  const middlewares = [routerMiddleware, reduxThunk];

  const store = createStore(
    rootReducer(routerReducer),
    init,
    composeEnhancers(applyMiddleware(...middlewares))
  );

  const history = createReduxHistory(store);

  return { store, history };
}

const initialState = {};

const { store, history } = configureStore(initialState);
export { history };
export default store;
